/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { AdminFilters } from './';
import {
    AdminFiltersFromJSON,
    AdminFiltersFromJSONTyped,
    AdminFiltersToJSON,
} from './';
import type { FilterItem } from './';
import {
    FilterItemFromJSON,
    FilterItemFromJSONTyped,
    FilterItemToJSON,
} from './';
import type { PriceHistogramFilter } from './';
import {
    PriceHistogramFilterFromJSON,
    PriceHistogramFilterFromJSONTyped,
    PriceHistogramFilterToJSON,
} from './';

/**
 * 
 * @export
 * @interface FiltersResponse
 */
export interface FiltersResponse {
    /**
     * 
     * @type {Array<FilterItem>}
     * @memberof FiltersResponse
     */
    badges: Array<FilterItem>;
    /**
     * 
     * @type {Array<FilterItem>}
     * @memberof FiltersResponse
     */
    experienceLevels: Array<FilterItem>;
    /**
     * 
     * @type {Array<FilterItem>}
     * @memberof FiltersResponse
     */
    categories: Array<FilterItem>;
    /**
     * 
     * @type {Array<FilterItem>}
     * @memberof FiltersResponse
     */
    languages: Array<FilterItem>;
    /**
     * 
     * @type {Array<FilterItem>}
     * @memberof FiltersResponse
     */
    businessSectors: Array<FilterItem>;
    /**
     * 
     * @type {Array<FilterItem>}
     * @memberof FiltersResponse
     */
    specialities: Array<FilterItem>;
    /**
     * 
     * @type {PriceHistogramFilter}
     * @memberof FiltersResponse
     */
    priceHistogram: PriceHistogramFilter;
    /**
     * 
     * @type {AdminFilters}
     * @memberof FiltersResponse
     */
    adminFilters?: AdminFilters;
}

/**
 * Check if a given object implements the FiltersResponse interface.
 */
export function instanceOfFiltersResponse(value: object): value is FiltersResponse {
    if (!('badges' in value) || value['badges'] === undefined) return false;
    if (!('experienceLevels' in value) || value['experienceLevels'] === undefined) return false;
    if (!('categories' in value) || value['categories'] === undefined) return false;
    if (!('languages' in value) || value['languages'] === undefined) return false;
    if (!('businessSectors' in value) || value['businessSectors'] === undefined) return false;
    if (!('specialities' in value) || value['specialities'] === undefined) return false;
    if (!('priceHistogram' in value) || value['priceHistogram'] === undefined) return false;
    return true;
}

export function FiltersResponseFromJSON(json: any): FiltersResponse {
    return FiltersResponseFromJSONTyped(json, false);
}

export function FiltersResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FiltersResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'badges': ((json['badges'] as Array<any>).map(FilterItemFromJSON)),
        'experienceLevels': ((json['experienceLevels'] as Array<any>).map(FilterItemFromJSON)),
        'categories': ((json['categories'] as Array<any>).map(FilterItemFromJSON)),
        'languages': ((json['languages'] as Array<any>).map(FilterItemFromJSON)),
        'businessSectors': ((json['businessSectors'] as Array<any>).map(FilterItemFromJSON)),
        'specialities': ((json['specialities'] as Array<any>).map(FilterItemFromJSON)),
        'priceHistogram': PriceHistogramFilterFromJSON(json['priceHistogram']),
        'adminFilters': json['adminFilters'] == null ? undefined : AdminFiltersFromJSON(json['adminFilters']),
    };
}

export function FiltersResponseToJSON(value?: FiltersResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'badges': ((value['badges'] as Array<any>).map((v) => FilterItemToJSON(v))),
        'experienceLevels': ((value['experienceLevels'] as Array<any>).map((v) => FilterItemToJSON(v))),
        'categories': ((value['categories'] as Array<any>).map((v) => FilterItemToJSON(v))),
        'languages': ((value['languages'] as Array<any>).map((v) => FilterItemToJSON(v))),
        'businessSectors': ((value['businessSectors'] as Array<any>).map((v) => FilterItemToJSON(v))),
        'specialities': ((value['specialities'] as Array<any>).map((v) => FilterItemToJSON(v))),
        'priceHistogram': PriceHistogramFilterToJSON(value['priceHistogram']),
        'adminFilters': AdminFiltersToJSON(value['adminFilters']),
    };
}

